import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BlurImageBackground from "@/components/BlurImageBackground";
import DetailButton from "@/components/DetailButton";
import SliderCore from "@/components/SliderCore";
import VersatileLink from "@/components/VersatileLink";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import routes from "@/lib/routes";
import styles from "@/styles/Carousel.module.scss";
import Image from "next/legacy/image";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const sliderOptions = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  navigation: true,
  pagination: {
    clickable: true
  },
  speed: 500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  }
};
function CarouselItem(_ref) {
  var _item$channel;
  let {
    item
  } = _ref;
  const detailLink = useMemo(() => {
    if (item.__typename === "EpisodeMeta" || item.__typename === "LiveMeta") {
      return routes.watch(item.id);
    } else if (item.__typename === "TVShowMeta") {
      return routes.title(item.id);
    } else if (item.__typename === "ChannelMeta") {
      return routes.channelDetail(item.id);
    } else if (item.__typename === "Advert") {
      return item.url;
    }
  }, [item]);
  const imagePreloadOption = {
    priority: true,
    loading: "eager"
  };
  const channelId = Number(item === null || item === void 0 || (_item$channel = item.channel) === null || _item$channel === void 0 ? void 0 : _item$channel.id);
  const showValuePlanLabel = isShowValuePlanLabel({
    channelId
  });
  return /*#__PURE__*/_jsx("div", {
    className: styles.item,
    children: /*#__PURE__*/_jsx(BlurImageBackground, {
      className: "carousel",
      item: item,
      imageOptions: imagePreloadOption,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.info,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.title,
            children: /*#__PURE__*/_jsx(VersatileLink, {
              href: detailLink,
              children: /*#__PURE__*/_jsx("a", {
                children: item.name
              })
            })
          }), /*#__PURE__*/_jsx("p", {
            className: styles.description,
            children: item.description
          }), /*#__PURE__*/_jsx(DetailButton, {
            href: detailLink,
            className: styles.detailBtn
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.artwork,
          children: /*#__PURE__*/_jsx(VersatileLink, {
            href: detailLink,
            className: styles.link,
            children: /*#__PURE__*/_jsxs("a", {
              children: [!!(item !== null && item !== void 0 && item.thumbnailUrl) && /*#__PURE__*/_jsx(Image, _objectSpread({
                src: item.thumbnailUrl,
                alt: item.name,
                width: 704,
                height: 396,
                layout: "responsive"
              }, imagePreloadOption)), showValuePlanLabel && /*#__PURE__*/_jsx("div", {
                className: styles.valueplanLabel,
                children: /*#__PURE__*/_jsx(Image, {
                  src: "/images/valueplan_label.png",
                  alt: "valueplan_label",
                  layout: "fill",
                  objectFit: "cover"
                })
              })]
            })
          })
        })]
      })
    })
  });
}
export default function Carousel(_ref2) {
  let {
    items
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: items && /*#__PURE__*/_jsx(SliderCore, {
      sliderOptions: sliderOptions,
      children: items.map((item, i) => /*#__PURE__*/_jsx(CarouselItem, {
        item: item
      }, `carousel-${i}`))
    })
  });
}